import { IndexContainer, IndexHeader, CardGrid, IndexCard } from '../../../styles/global'

export function PlumbingIndex() {
  const gradient = 'linear-gradient(135deg, #0891b2 0%, #0e7490 100%)'
  const accentColor = '#0891b2'

  const calculators = [
    {
      title: 'Águas Pluviais',
      description:
        'Calculadora para dimensionamento de sistemas de drenagem de águas pluviais, considerando área de contribuição e intensidade de chuva',
      path: '/hidrossanitario/pluvial',
      icon: '🌧️',
      popular: true,
    },
    {
      title: 'Reservatório',
      description:
        'Calculadora para dimensionamento de reservatórios de água potável, considerando consumo diário, número de usuários e tempo de autonomia desejado. Útil para garantir abastecimento contínuo e adequado',
      path: '/hidrossanitario/reservatorio',
      icon: '💧',
      popular: true,
    },
    {
      title: 'Fossa Séptica',
      description:
        'Calculadora para dimensionamento de fossa séptica com base no número de usuários, contribuição diária de esgoto e tempo de detenção. Ideal para residências unifamiliares ou edificações de pequeno porte',
      path: '/hidrossanitario/fossa',
      icon: '🚽',
      popular: false,
    },
  ]

  return (
    <IndexContainer>
      <IndexHeader $gradient={gradient}>
        <div className="header-content">
          <h1>💧 Hidrossanitário</h1>
          <p className="subtitle">
            Ferramentas completas para dimensionamento de sistemas hidráulicos e sanitários em edificações
          </p>
          <div className="stats">
            <div className="stat-item">
              <span className="stat-number">{calculators.length}</span>
              <span className="stat-label">Calculadoras</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{calculators.filter((c) => c.popular).length}</span>
              <span className="stat-label">Mais Usadas</span>
            </div>
          </div>
        </div>
      </IndexHeader>

      <div className="content-wrapper">
        <h2>Calculadoras Disponíveis</h2>
        <CardGrid>
          {calculators.map((calc, index) => (
            <IndexCard
              key={index}
              to={calc.path}
              $popular={calc.popular}
              $gradient={gradient}
              $accentColor={accentColor}
            >
              {calc.popular && <span className="popular-badge">Popular</span>}
              <span className="card-icon">{calc.icon}</span>
              <h3>{calc.title}</h3>
              <p>{calc.description}</p>
              <span className="arrow">→</span>
            </IndexCard>
          ))}
        </CardGrid>
      </div>
    </IndexContainer>
  )
}
